(function() {
  'use strict';

  angular.module('blocks.localstorage', []);
})();
